import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withModifiers as _withModifiers, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-755e63aa")

_pushScopeId("data-v-755e63aa")
const _hoisted_1 = { class: "full_container" }
const _hoisted_2 = { class: "grid_container" }
const _hoisted_3 = { class: "logo_container" }
const _hoisted_4 = { class: "form_container ion-padding-horizontal" }
const _hoisted_5 = { class: "email_input" }
const _hoisted_6 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Email", -1)
const _hoisted_7 = {
  key: 0,
  class: "password_input"
}
const _hoisted_8 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Password", -1)
const _hoisted_9 = {
  key: 1,
  class: "code_input"
}
const _hoisted_10 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Codice di verifica", -1)
const _hoisted_11 = {
  key: 2,
  class: "ricordami_input"
}
const _hoisted_12 = /*#__PURE__*/_createVNode("div", { class: "label" }, "Ricordami", -1)
const _hoisted_13 = { class: "message_container" }
const _hoisted_14 = {
  key: 0,
  class: "email_buttons"
}
const _hoisted_15 = {
  key: 1,
  class: "password_buttons"
}
const _hoisted_16 = {
  key: 2,
  class: "code_buttons"
}
const _hoisted_17 = /*#__PURE__*/_createTextVNode(" Come installare l'applicazione ")
const _hoisted_18 = { class: "logo_ingegno" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_ion_col = _resolveComponent("ion-col")
  const _component_ion_row = _resolveComponent("ion-row")
  const _component_ion_input = _resolveComponent("ion-input")
  const _component_ion_checkbox = _resolveComponent("ion-checkbox")
  const _component_ion_button = _resolveComponent("ion-button")
  const _component_ion_grid = _resolveComponent("ion-grid")
  const _component_ion_loading = _resolveComponent("ion-loading")
  const _component_ion_content = _resolveComponent("ion-content")
  const _component_ion_page = _resolveComponent("ion-page")

  return (_openBlock(), _createBlock(_component_ion_page, null, {
    default: _withId(() => [
      _createVNode(_component_ion_content, { fullscreen: true }, {
        default: _withId(() => [
          _createVNode("div", _hoisted_1, [
            _createVNode("div", _hoisted_2, [
              _createVNode(_component_ion_grid, null, {
                default: _withId(() => [
                  _createVNode(_component_ion_row, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_col, { class: "ion-padding" }, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_3, [
                            _createVNode("img", {
                              src: _ctx.getAssetUrl('assets/logo.png')
                            }, null, 8, ["src"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  }),
                  _createVNode("form", {
                    onSubmit: _cache[12] || (_cache[12] = _withModifiers(($event: any) => (_ctx.handleFormSubmit()), ["prevent"]))
                  }, [
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_4, [
                          _createVNode("div", _hoisted_5, [
                            _hoisted_6,
                            _createVNode(_component_ion_input, {
                              type: "email",
                              modelValue: _ctx.email,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => (_ctx.email = $event)),
                              placeholder: "La tua email",
                              required: "",
                              disabled: _ctx.loginStep === 'code_sent'
                            }, null, 8, ["modelValue", "disabled"])
                          ]),
                          (_ctx.showPasswordField)
                            ? (_openBlock(), _createBlock("div", _hoisted_7, [
                                _hoisted_8,
                                _createVNode(_component_ion_input, {
                                  type: "password",
                                  modelValue: _ctx.password,
                                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => (_ctx.password = $event)),
                                  placeholder: "La tua password",
                                  required: ""
                                }, null, 8, ["modelValue"]),
                                _createVNode("div", {
                                  class: "forgot_password",
                                  onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.openRecoveryPassword()))
                                }, "Password dimenticata?")
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.loginStep === 'code_sent')
                            ? (_openBlock(), _createBlock("div", _hoisted_9, [
                                _hoisted_10,
                                _createVNode(_component_ion_input, {
                                  type: "text",
                                  modelValue: _ctx.verificationCode,
                                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => (_ctx.verificationCode = $event)),
                                  placeholder: "Inserisci il codice a 5 cifre ricevuto via email",
                                  maxlength: "5",
                                  required: ""
                                }, null, 8, ["modelValue"]),
                                _createVNode("div", {
                                  class: "resend_code",
                                  onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.resendCode()))
                                }, "Non hai ricevuto il codice? Invia di nuovo")
                              ]))
                            : _createCommentVNode("", true),
                          (_ctx.showPasswordField)
                            ? (_openBlock(), _createBlock("div", _hoisted_11, [
                                _hoisted_12,
                                _createVNode(_component_ion_checkbox, {
                                  class: "ion-margin-end",
                                  modelValue: _ctx.ricordami,
                                  "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => (_ctx.ricordami = $event))
                                }, null, 8, ["modelValue"])
                              ]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, null, {
                          default: _withId(() => [
                            _createVNode("div", _hoisted_13, [
                              (_ctx.message)
                                ? (_openBlock(), _createBlock("div", {
                                    key: 0,
                                    class: ["message", _ctx.messageType]
                                  }, _toDisplayString(_ctx.message), 3))
                                : _createCommentVNode("", true)
                            ])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_ion_row, null, {
                      default: _withId(() => [
                        _createVNode(_component_ion_col, { class: "ion-padding" }, {
                          default: _withId(() => [
                            (_ctx.loginStep === 'email')
                              ? (_openBlock(), _createBlock("div", _hoisted_14, [
                                  _createVNode("button", {
                                    size: "default",
                                    type: "button",
                                    class: "btn_login",
                                    onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.continueWithEmail())),
                                    disabled: _ctx.loading
                                  }, _toDisplayString(_ctx.loading ? 'Verifica in corso...' : 'Continua con codice via email'), 9, ["disabled"]),
                                  _createVNode("button", {
                                    size: "default",
                                    type: "button",
                                    class: "btn_login btn_secondary",
                                    onClick: _cache[8] || (_cache[8] = ($event: any) => (_ctx.showPasswordLogin())),
                                    disabled: _ctx.loading
                                  }, " Accedi con password ", 8, ["disabled"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.loginStep === 'password')
                              ? (_openBlock(), _createBlock("div", _hoisted_15, [
                                  _createVNode("button", {
                                    size: "default",
                                    type: "submit",
                                    class: "btn_login",
                                    disabled: _ctx.loading || !_ctx.password
                                  }, _toDisplayString(_ctx.loading ? 'Login in corso...' : 'Login'), 9, ["disabled"]),
                                  _createVNode("button", {
                                    type: "button",
                                    class: "btn_login btn_secondary",
                                    onClick: _cache[9] || (_cache[9] = ($event: any) => (_ctx.backToEmailStep())),
                                    disabled: _ctx.loading
                                  }, " Accedi con codice via email ", 8, ["disabled"])
                                ]))
                              : _createCommentVNode("", true),
                            (_ctx.loginStep === 'code_sent')
                              ? (_openBlock(), _createBlock("div", _hoisted_16, [
                                  _createVNode("button", {
                                    size: "default",
                                    type: "button",
                                    class: "btn_login",
                                    onClick: _cache[10] || (_cache[10] = ($event: any) => (_ctx.verifyCode())),
                                    disabled: _ctx.loading || !_ctx.verificationCode || _ctx.verificationCode.length !== 5
                                  }, _toDisplayString(_ctx.loading ? 'Verifica in corso...' : 'Verifica codice'), 9, ["disabled"]),
                                  _createVNode("button", {
                                    type: "button",
                                    class: "btn_login btn_secondary",
                                    onClick: _cache[11] || (_cache[11] = ($event: any) => (_ctx.showPasswordLogin())),
                                    disabled: _ctx.loading
                                  }, " Accedi con password ", 8, ["disabled"])
                                ]))
                              : _createCommentVNode("", true),
                            _createVNode(_component_ion_button, {
                              color: "secondary",
                              fill: "clear",
                              size: "small",
                              expand: "full",
                              onClick: _ctx.openModal,
                              class: "btn_helper"
                            }, {
                              default: _withId(() => [
                                _hoisted_17
                              ]),
                              _: 1
                            }, 8, ["onClick"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ], 32),
                  _createVNode(_component_ion_row, null, {
                    default: _withId(() => [
                      _createVNode(_component_ion_col, null, {
                        default: _withId(() => [
                          _createVNode("div", _hoisted_18, [
                            _createVNode("img", {
                              src: _ctx.getAssetUrl('assets/logo_ingegno.png')
                            }, null, 8, ["src"])
                          ])
                        ]),
                        _: 1
                      })
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ])
          ]),
          _createVNode(_component_ion_loading, {
            "is-open": _ctx.loading,
            message: "Autenticazione in corso",
            duration: 5000,
            onDidDismiss: _cache[13] || (_cache[13] = ($event: any) => (_ctx.setOpen(false)))
          }, null, 8, ["is-open"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
})